// JsFromRoutes CacheKey b49ad30cce385fd76accd84465fd83b1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/templates/:template_id/template_versions'),
  list: definePathHelper('get', '/templates/:template_id/template_versions'),
}
